import { RootSelector, getStore } from '../../reducers';
import { TagBinderShape } from './model';
import { createSelector } from '@reduxjs/toolkit';
import { Tag } from '../../api';

export const getTagBinder: RootSelector<TagBinderShape> = createSelector(
  getStore,
  (state) => state.tagBinder,
);

export const getTags: RootSelector<Tag[]> = createSelector(
  getTagBinder,
  (tagBinder) => tagBinder.tags,
);

export const getVisible: RootSelector<boolean> = createSelector(
  getTagBinder,
  (tagBinder) => tagBinder.visible,
);

export const getInProgress: RootSelector<boolean> = createSelector(
  getTagBinder,
  (tagBinder) => tagBinder.inProgress,
);

export const getDropdownOptions: RootSelector<
  {
    label: string;
    value: number;
  }[]
> = createSelector(getTags, (tags) => tags.map(({ name, id }) => ({ label: name, value: id })));
